import { api } from "@/api/client";
import { z } from "zod";

export const RegionSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type Region = z.infer<typeof RegionSchema>;

export function getRegions() {
  return api.get<Region[]>("williams/regions");
}
